import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

class ReportsActionTypes extends AbstractApiActionTypes {
  SET_LIST_PAGE = "reports/SET_LIST_PAGE";

  SET_LIST_ROWS_PER_PAGE = "reports/SET_LIST_ROWS_PER_PAGE";
}

export default new ReportsActionTypes("reports");
